<template>
  <div class="user">
    <div class="user-pic">
      <img :src="personInfo && personInfo.avatar_url || 'https://files.wondercv.com/default_forum_icon.png'" alt="" class="user-avatar">
      <img v-if="personInfo.is_membership" src='https://photo.wondercv.com/vip-icon.png' class='member-icon'>
    </div>

    <div class="personal-menu">
      <div class="personal-title">
        <div class="user-avatar">
          <img :src="personInfo && personInfo.avatar_url || 'https://files.wondercv.com/default_forum_icon.png'" alt="" class="user-avatar">
        </div>
        <div class="user-name">
          <span>{{ personInfo.name || personInfo.username }}</span>
          <img :src="personInfo.is_membership ? 'https://files.wondercv.com/PC/navbar/me/membership_gold.png' : 'https://files.wondercv.com/PC/navbar/me/membership_gray.png'" alt="">
        </div>
        <div class="member-tips text-overflow">
          <p v-if="personInfo.is_membership && personInfo.group_name" style="margin: 2px 0">{{ `${personInfo.group_name}ss专属会员` }}</p>
          <p v-if="personInfo.is_membership">
            {{ isOverMember ? '您已成为超级简历终身会员' : `会员有效期至 ${moment(personInfo.membership_expired_at).format('YYYY-MM-DD')}`}}
          </p>
          <span v-else>
            开通超级会员，尊享6大特权
          </span>
        </div>
        <!--不是会员 || 是会员但不是终身会员-->
        <div class="member-btn" v-if="!personInfo.is_membership || !isOverMember">
          <div class="cursor_p is-member" @click="member" v-if="personInfo.is_membership">续费 VIP 会员</div>
          <div class="cursor_p no-member" @click="member" v-else>立即开通</div>
        </div>
      </div>
<!--      <div class="menu-title" v-if="personInfo.is_membership">-->
<!--        <p class="t">{{personInfo.group_name || '超级会员'}}{{personInfo.group_name && 'ss专属会员'}}</p>-->
<!--        -->
<!--        <p class="text-overflow" style="color: #000;">{{ (personInfo.membership_expired_at.substr(0,4)) < 2100 ? moment(personInfo.membership_expired_at).format('YYYY-MM-DD')+'到期' : '您已经是超级简历终身会员'}}-->
<!--          <button v-if="personInfo.is_membership && !personInfo.group_name && (personInfo.membership_expired_at.substr(0,4))<2100" class="member-btn" @click="member">续费</button>-->
<!--        </p>-->

<!--      </div>-->
<!--      <div class="menu-title" v-else>-->
<!--        <p class="t" style="color:#404040">开通<span style="color:#FF4F4C">会员</span>-->
<!--          享等多权益</p>-->
<!--        <p class="text-overflow" style="color: #000;width:170px" >-->
<!--          <button  class="member-btn" @click="member" style="width:72px">立即开通</button>-->
<!--        </p>-->
<!--      </div>-->
      <div class="menu-item" v-for="item in personalMenu" :key="item.label" @click="jumpModule(item)" :class="{'final-menu': item.label === '退出登录'}">
<!--        <img :src="item.icon" alt="">-->
        <div class="left">
          <span :class="`iconfont ${item.icon}`" />
          <span>{{item.label}}</span>
        </div>
        <div class="right">
          <span class="iconfont iconchevron-right" v-if="item.label !== '退出登录'"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import moment from 'moment';
  import { routerTo } from '~/assets/js/util'
  import Cookies from 'js-cookie'
  window.Cookies = Cookies;
  import api from '@/api'

  const personalMenu = [
    {label: '账号设置', icon: 'iconzhanghaoshezhi1', url: '/account/users'},
    {label: '超级会员', icon: 'iconchaojihuiyuan', url: '/account/users/buy_member'},
    {label: '我的订单', icon: 'iconwodedingdan1', url: '/account/users?index=3'},
    {label: '问题反馈', icon: 'iconwentifankui', url: '/feedbacks/new'},
    {label: '我要招人', icon: 'iconwoyaozhaoren', url: `https://www.wondercv.${process.env.VUE_APP_EVN === 'staging' || process.env.VUE_APP_EVN === 'development' ? 'cn' : 'com'}/talent/binduser`, isHR: true},
    {label: '退出登录', icon: 'icontuichudenglu', url: 'signin?type=login'}
  ];
  export default {
    data() {
      return {
        personalMenu,
        moment
      }
    },
    watch: {
      personInfo: {
        deep: true,
        immediate: true,
        handler(personInfo) {
          let arr = [...personalMenu];
          // if (personInfo.admin) {
          //   let obj = {label: '管理入口', icon: 'https://files.wondercv.com/pc/navbar/manage.png', url: 'https://admin.wondercv.com'};
          //   arr.splice(arr.length - 1, 0, obj);
          // }
          // if (personInfo.group_name) {
          //   let obj = {label: '机构入口', icon: 'https://files.wondercv.com/pc/navbar/framework.png', url: personInfo.group_url};
          //   arr.splice(arr.length - 1, 0, obj);
          // }
          if (personInfo.mentor) {
            let obj = {label: '导师入口', icon: 'icondaoshirukou', url: '/mentor/tasks'};
            arr.splice(arr.length - 1, 0, obj);
          }
          this.personalMenu = arr;
        }
      }
    },
    computed: {
      ...mapState('me', ['isLogin', 'personInfo', 'isMembership', 'isUser']),
      // 是否是终身会员(是会员的前提下)
      isOverMember() {
        return this.personInfo && this.personInfo.is_membership && this.personInfo.membership_expired_at.substr(0,4) >= 2100
      }
    },
    created(){
      // console.log(this.personInfo,"=====>person")
    },
    methods: {
      // 会员续费
      async member() {
        this.$emit('clickItem')
        // let res = await api.cvsV2.membershipOrder({
        //   from_vue: 'true',
        //   improved_order: { package: 'membership' }
        // });
        routerTo(`/account/users/buy_member`);
      },
      async jumpModule (item) {
        this.$emit('clickItem')
        if (item.label === '退出登录') {
          if (confirm('确定退出登录么？')) {
            let url = window.location.hostname;
            let domain = url.replace(/.*?(\.wondercv.(cn|com))/gim, '$1');
            Cookies.remove('_t', {domain});
            Cookies.remove('_t_plugin', {domain});
            
            // 增加登录之后自动跳转活到相应页面。过期时间1小时
            var exp = new Date();
            exp.setTime(exp.getTime() + 30 * 24 * 60 * 60 * 1000);//过期时间 30天
            let { pathname, hostname } = window.location;
            document.cookie = `_r_b_t=${encodeURIComponent(window.location.href)}; domain=${hostname.split('.')[1]}.${hostname.split('.')[2]}; expires=${exp.toGMTString()}; path=/`

            routerTo('/auth-signin/?type=login');
          }
        }
        // else if (item.isHR) {
        //   routerTo(item.url, '_blank')
        //   // window.location.href = item
        // }
        else {
          routerTo(item.url, '_blank')
        }
      },
    }
  }
</script>
<style lang="scss" scoped>
  @import '~/assets/css/variable';
  .user {
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: -3px;
    cursor: pointer;
    .user-pic {
      width: 34px;
      height: 56px;
      overflow: hidden;
      position: relative;
      img {
        width: 30px;
        height: 30px;
        border-radius: 15px;
        margin-top: 13px;
      }
      img.member-icon{
        width: 12px;
        height: 12px;
        position: absolute;
        bottom: 12px;
        right: 0;
      }
      img.user-avatar {
        background: url('https://files.wondercv.com/default_forum_icon.png') no-repeat;
        background-size: 30px;
        object-fit: cover;
      }
    }
    &>img {
      width: 25px;
      height: 25px;
      margin-top: 1px;
      &.v {
        width: 36px;
        height: 36px;
        margin-right: -9px;
        margin-left: -2px;
      }
    }
    &:hover .personal-menu {
      display: block;
    }
    .personal-menu {
      position: absolute;
      right: -15px;
      bottom: 0;
      transform: translateY(100%);
      width: 220px;
      background-color: $color-light;
      //padding: 5px 0;
      margin: 0px 0;
      border: 1px solid rgba(0, 0, 0, 0.15);
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
      border-radius: 4px;
      display: none;
      .personal-title {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        //padding-top: 18px;
        padding: 18px 0 16px;
        border-bottom: 1px solid #F4F4F4;
        .user-avatar {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .user-name {
          color: #404040;
          font-size: 15px;
          font-weight: 500;
          margin-top: 6px;
          display: flex;
          align-items: center;
          img {
            width: 20px;
            height: 16px;
          }
        }
        .member-tips {
          color: #9c9c9c;
          font-size: 12px;
          margin-top: 4px;
          line-height: 17px;
        }
        .member-btn {
          text-align: center;
          line-height: 28px;
          font-size: 12px;
          .is-member {
            width: 160px;
            height: 28px;
            border-radius: 14px;
            border: 1px solid #FF8569;
            color: #ff6644;
            margin-top: 8px;
            &:hover {
              border-color: #FF6644;
              background-color: #FF6644;
              color: #fff;
            }
          }
          .no-member {
            width: 160px;
            height: 28px;
            border-radius: 14px;
            background-color: #ff6644;
            color: #fff;
            margin-top: 8px;
            &:hover {
              background-color: #FF8569;
            }
          }
        }
      }
      .menu-title {
        // min-height: 60px;
        // max-width: 180px;
        // width: 80%;
        margin: auto;
        text-align: center;
        position: relative;
        overflow: hidden;
        cursor: auto;
        padding-bottom: 8px;
        margin-bottom: 2px;
        &::after {
          content: "";
          display: block;
          width: 100%;
          height: 1px;
          background: #F2F2F2;
          position: absolute;
          left: 8px;
          bottom: 0;
        }
        .t {
          color: #ff4f4c;
          padding-top: 14px;
          padding-bottom: 8px;
          line-height: 20px;
        }
        p {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .member-btn {
          width: 44px;
          height: 24px;
          background: #ff4f4c;
          font-size: 14px;
          color: #fff;
          display: block;
          border-radius: 2px;
          margin-left: 25px;
        }
      }
      .final-menu {
        border-top: 6px solid #f9f9f9;
      }
      .menu-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 52px;
        padding: 0 25px;
        cursor: pointer;
        .left {
          display: flex;
          align-items: center;
          .iconfont {
            color: #000;
            font-size: 18px;
            margin-right: 13px;
          }
        }
        .right {
          .iconfont {
            color: #cfcfcf;
            font-size: 14px;
          }
        }
        &:hover {
          background-color: #f5f5f5;
        }
        //img {
        //  max-width: 14px;
        //  max-height: 14px;
        //  margin: 0 20px;
        //}
      }
    }
  }
  .vip {
    display: flex;
    align-items: center;
    color: #50a4ff;
    cursor: pointer;
    margin-right: 0px;
    img {
      width: 17px;
      height: 17px;
      margin-right: 2px;
    }
  }
</style>
